import script from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=03589b0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03589b0c"]])

export default __exports__